module.exports = __webpack_public_path__ + "static/media/blue-credit-card.46db535d.svg";